// extracted by mini-css-extract-plugin
export default {"reminder_styles":"timeoutOrder_reminder_styles__mOe2M","inline":"timeoutOrder_inline__Ezkph","width-50":"timeoutOrder_width-50__wJ3FG"};